import type { MouseEventHandler } from "react";
import type { NextRouter } from "next/router";
import { isFrappeOrJotFormClass } from "./helpers";

export const APPLY_ONBOARDING_PATH = "/onboarding" as const;

export type GetOnboardingOrFormCtaPropsOptions = {
  btnLink?: string | null;
  formId?: string | number | null;
  toOnboardingEnabled?: boolean;
  formKeyFromEnv?: string;
  sourceUrl?: string;
};

export type ApplyCtaButtonProps = {
  formClassName: string;
  onClick: MouseEventHandler<HTMLButtonElement> | undefined;
  mode: "onboarding" | "form" | "link";
};

export function getOnboardingOrFormCtaProps(
  router: NextRouter,
  {
    btnLink,
    formId,
    toOnboardingEnabled = false,
    formKeyFromEnv = process.env.NEXT_PUBLIC_COMMON_FRAPPE_FORM,
    sourceUrl = "",
  }: GetOnboardingOrFormCtaPropsOptions,
): ApplyCtaButtonProps {
  // 1. An explicit link always wins: open it in a new tab.
  if (btnLink) {
    const onClick: MouseEventHandler<HTMLButtonElement> = (e) => {
      e.preventDefault();
      e.stopPropagation();
      window.open(btnLink, "_blank");
    };
    return { formClassName: "", onClick, mode: "link" };
  }

  // 2. A form id wins over onboarding: the Frappe/JotForm class handles the
  //    click itself, so the React onClick is a no-op.
  if (formId) {
    const onClick: MouseEventHandler<HTMLButtonElement> = () => {
      return;
    };
    return { formClassName: isFrappeOrJotFormClass(formId), onClick, mode: "form" };
  }

  // 3. No link and no form id: go to onboarding when enabled, otherwise fall
  //    back to the common form.
  if (toOnboardingEnabled) {
    const onClick: MouseEventHandler<HTMLButtonElement> = (e) => {
      e.preventDefault();
      e.stopPropagation();
      const path = window.location.pathname.replace(/^\//, "");
      window.location.href =
        APPLY_ONBOARDING_PATH + `?source_url=${sourceUrl ? sourceUrl : path}`;
    };
    return { formClassName: "", onClick, mode: "onboarding" };
  }

  const onClick: MouseEventHandler<HTMLButtonElement> = () => {
    return;
  };
  return {
    formClassName: isFrappeOrJotFormClass(formKeyFromEnv),
    onClick,
    mode: "form",
  };
}
